// extracted by mini-css-extract-plugin
module.exports = {"container":"checkout_container__1pHCJ","checkout":"checkout_checkout__qPo-L","role":"checkout_role__18IZA","icon":"checkout_icon__2iRTO"};